export const INTEGRATION_EMPTY_MESSAGES = [
    "No integrations connected yet.",
    "Nothing installed here yet — browse the catalog to get started.",
    "This is where your connected systems will live.",
    "Ready when you are — add your first integration.",
    "No integrations found.",
];

export const CUSTOM_WEBHOOK_TEMPLATE_KEY = "custom_webhook";
